let basePath = process.env.REST_PATH
let apiPath =process.env.API_REST_PATH

// PATH SERVIZI HOME
export const HOME_PATH_INIT="/home"


// PATH SERVIZI REST
export const PATH_TIPOLOGICHE = basePath+apiPath+"/compilazione/valoriTipologica?";
export const PATH_TRAMISSIONE_PEGNO_QUALIFICA_RICHIEDENTE = basePath+apiPath+"/trasmissionepegno/qualificaRichiedente";
export const PATH_TRAMISSIONE_DUPLO_QUALIFICA_RICHIEDENTE = basePath+apiPath+"/trasmissioneDuplo/qualificaRichiedente";
export const PATH_TRAMISSIONE_COM_CANC_QUALIFICA_RICHIEDENTE = basePath+apiPath+"/trasmissionecomcanc/qualificaRichiedente";

export const PATH_TRAMISSIONE_UNIMOD_QUALIFICA_RICHIEDENTE = basePath+apiPath+"/trasmissioneunimod/qualificaRichiedente";
export const PATH_TRAMISSIONE_PEGNO_CERT_QUALIFICA_RICHIEDENTE = basePath+apiPath+"/trasmissionePegnoCertificati/qualificaRichiedente";
export const PATH_UFFICI_CONVERVATORIE = basePath+apiPath+"/trasmissioneunimod/ufficiEntrate?tipoUfficio=CO&stato=";
export const PATH_PROVINCE = basePath+apiPath+"/compilazione/province";
export const PATH_TIPOLOGICHE_UN = basePath+apiPath+"/compilazione/valoriTipologica?tipoPratica=UN&tipoRich=";
export const PATH_COMUNI = basePath+apiPath+"/compilazione/comuni?prov=";


export const PATH_TRAMISSIONE_PEGNO_INVIO = basePath+apiPath+"/trasmissionepegno/invioPratica";
export const PATH_TRAMISSIONE_UNIMOD_INVIO = basePath+apiPath+"/trasmissioneunimod/invioPratica";
export const PATH_TRAMISSIONE_PEGNO_CERT_INVIO = basePath+apiPath+"/trasmissionePegnoCertificati/invioPratica";
export const PATH_TRASMISSIONE_COM_CANC = basePath+apiPath+"/trasmissionecomcanc/invioPratica";



export const PATH_ESITI_PRIMO_LIVELLO_PEGNO = basePath+apiPath+"/trasmissionepegno/esitiPrimoLivello";
export const PATH_ESITI_SECONDO_LIVELLO_PEGNO = basePath+apiPath+"/trasmissionepegno/esitiSecondoLivello";

export const PATH_ESITI_PRIMO_LIVELLO_PEGNO_CERT = basePath+apiPath+"/trasmissionePegnoCertificati/esitiPrimoLivello";
export const PATH_ESITI_SECONDO_LIVELLO_PEGNO_CERT = basePath+apiPath+"/trasmissionePegnoCertificati/esitiSecondoLivello";

export const PATH_ESITI_PRIMO_LIVELLO_UNICO = basePath+apiPath+"/trasmissioneunimod/esitiPrimoLivello";
export const PATH_ESITI_SECONDO_LIVELLO_UNICO = basePath+apiPath+"/trasmissioneunimod/esitiSecondoLivello";
export const PATH_ESITI_TERZO_LIVELLO_UNICO = basePath+apiPath+"/trasmissioneunimod/esitiTerzoLivello";



export const PATH_LISTA_ANNI = basePath+apiPath+"/trasmissionecomcanc/lista-anni?";
export const PATH_ELENCHI_CI = basePath+apiPath+"/trasmissionecomcanc/esitiPrimoLivello/ente";
export const PATH_ESITI_PRIMO_LIVELLO_CI = basePath+apiPath+"/trasmissionecomcanc/esitiPrimoLivello";
export const PATH_ESITI_SECONDO_LIVELLO_CI = basePath+apiPath+"/trasmissionecomcanc/esitiSecondoLivello";


export const PATH_AVVISI_UNICO = basePath+apiPath+"/trasmissioneunimod/esitiDettaglioAvvisiPagamento";
export const PATH_DATI_PAGAMENTO_INTEGRATIVO = basePath+apiPath+"/trasmissioneunimod/datiPagamentoIntegrativo";
export const PATH_DOWNLOAD_PAGAMENTO_INTEGRATIVO = basePath+apiPath+"/trasmissioneunimod/downloadPagamentoIntegrativo";
export const PATH_RESTITUZIONE_DI_PARTE = basePath+apiPath+"/trasmissioneunimod/restituzioneDiParte";


export const PATH_SAVE_DATI_UTENTE = basePath+apiPath+"/compilazione/saveDatiUtente";
export const PATH_READ_DATI_UTENTE = basePath+apiPath+"/compilazione/readDatiUtente";

export const PATH_DOWNLOAD_FILE_PEGNO = basePath+apiPath+"/trasmissionepegno/downloadFile";
export const PATH_DOWNLOAD_FILE_UNICO = basePath+apiPath+"/trasmissioneunimod/downloadFile";
export const PATH_DOWNLOAD_FILE_DUPLO = basePath+apiPath+"/trasmissioneDuplo/downloadFile";
export const PATH_DOWNLOAD_FILE_CI = basePath+apiPath+"/trasmissionecomcanc/downloadFile";
export const PATH_ELENCO_CI = basePath+apiPath+"/trasmissionecomcanc/elenco-cancellazioni";

export const PATH_DOWNLOAD_FILE_PEGNO_CERT = basePath+apiPath+"/trasmissionePegnoCertificati/downloadFile";

export const PATH_GET_ID_ATMOS_UPLOAD_FLOW=basePath+apiPath+"/trasmissionepegno/upload/idAtmos" // richiama a sua volta /upload-be/api/upload/idAtmos
export const PATH_CHIAMATA_A2D = basePath+apiPath+"/trasmissionepegno/chiamataServizioA2D";
export const PATH_CONTROLLO_A2D = basePath+apiPath+"/trasmissionepegno/controlloDatiA2D";
//export const PATH_GET_ID_ATMOS_UPLOAD_FLOW="/upload-be/api/upload/idAtmos"
export const PATH_MENU_PRINCIPALE_PEGNO=basePath+apiPath+"/trasmissionepegno/menuItems?tipoMenu=X";
export const PATH_MENU_PRINCIPALE_UNIMOD=basePath+apiPath+"/trasmissioneunimod/menuItems?tipoMenu=X&keyProfUt=";
export const PATH_MENU_PRINCIPALE_PEGNO_CERT=basePath+apiPath+"/trasmissionePegnoCertificati/menuItems?tipoMenu=X";
export const PATH_MENU_PRINCIPALE_CI=basePath+apiPath+"/trasmissionecomcanc/menuItems?tipoMenu=X";

export const PATH_RICEVUTE_DUPLO= basePath+apiPath+"/trasmissioneDuplo/dupli-restituiti";
export const PATH_RICHIESTA_DUPLO= basePath+apiPath+"/trasmissioneDuplo/richiesta";

export const PATH_CONTROLLA_FERMO_PEGNO = basePath+apiPath+"/trasmissionepegno/controllaFermo";
export const PATH_CONTROLLA_FERMO_PEGNO_CERT = basePath+apiPath+"/trasmissionePegnoCertificati/controllaFermo";

export const PATH_CHIAMATA_STATOPRATICA = basePath+apiPath+"/trasmissionepegno/statoPratica";



// COSTANTI
export const SEPARATORE = "#@#";
export const IN_ATTESA_CONTROLLI_BLACKBOX = "01";